import React from 'react';
import BlockContent from '@sanity/block-content-to-react';
import CTALink from '../CTALink';
import './textComponent.scss';
import textCompLogo from '../../images/text-comp-logo.png';
import { TextComponentLayout } from '../../utils/utils';
import { serializers } from '../../utils/blockMarks';
import isurl from 'isurl';

import { getYouTubeVideoId, isValidURL, isYouTubeUrl } from '../../utils/helper';

const TextComponent = ({
  heading,
  eyebrow,
  description,
  linksBtn,
  layoutStyle,
  showIcon,
  phone,
  email,
  directionStyle,
  dateTime,
  blockText,
  address,
  ...props
}) => {
  /**
   * Comment will be removed when it fullfilled comment
   * need to refactor the text component only props argument from function args and then destructured it
   */
  const renderLink = ({ title, linkTo, className }) => {
    let u = "";
    try {
       u = new URL(linkTo);
    
    } catch(error) {
      if(error instanceof TypeError) {
        u = linkTo
      } //just to check if TypeError, probably not necessary for your use
    }
  
    const isOpenInNewTab = isValidURL(u || '') && new URL(linkTo);
      //console.log(linkTo,":",isValidURL(linkTo || ''),":",isOpenInNewTab,":",window.location.hostname,":",isOpenInNewTab.hostname)
    return (  
      <CTALink
        key={Math.random().toString(36).substring(7)}
        openInNewTab={typeof window !== 'undefined' && window.location.hostname !== isOpenInNewTab.hostname}
        isYouTubeLink={getYouTubeVideoId(linkTo)}
        text={title}
        linkTo={linkTo || '/'}
        layoutStyle={className}
      />
    );
  };
  const getLayoutStyle = (style) => {
    switch (style) {
      case TextComponentLayout.CENTER:
        return 'text-center';
      case TextComponentLayout.LEFT:
        return 'text-left style-2';
      case TextComponentLayout.RIGHT:
        return 'text-right';
      case TextComponentLayout.BIG:
        return 'text-big';
      default:
        return 'text-left';
    }
  };
  return (
    <div className={`text-container ${getLayoutStyle(layoutStyle)} ${directionStyle || ''}`}>
      <div className="text-inner">
        {showIcon && (
          <div className="text-icon">
            <img className="img-responsive" src={textCompLogo} alt="turfmutt" />
          </div>
        )}
        {eyebrow && <h5 className="text-eyebrow">{eyebrow}</h5>}
        {heading && <h2 className="text-title">{heading}</h2>}
        {(dateTime || address) && (
          <div className="dateTime-and-add-wrapper caption">
            {dateTime && <span className="date-time-span">{dateTime}</span>}
            {address && <span className="address-span">{address}</span>}
          </div>
        )}
        {description && (
          <div className="text-desc">
            {typeof description === 'string' ? <p>{description}</p> : <BlockContent blocks={description} serializers={serializers} />}
          </div>
        )}
        {linksBtn && <div className="text-btns">{linksBtn.map((link) => renderLink(link))}</div>}
        {phone && (
          <div className="text-btns">
            PHONE:
            <a className="btn-link" href={`tel:${phone}`}>
              {phone}
            </a>
          </div>
        )}
        {email && (
          <div className="text-btns">
            EMAIL:
            <a className="btn-link" href={`mailto:${email}`}>
              {` ${email}`}
            </a>
          </div>
        )}
      </div>
      {props.children}
    </div>
  );
};

export default TextComponent;
